import React, { useMemo } from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectThemeById,
  themeGroupings,
} from '../../store/constants/themeGroupings';
import { selectTheme } from '../../store/options/options.selector';
import { changeTheme } from '../../store/options/options.slice';

import {
  getDataAsync,
  getProjectionDataAsync,
} from '../../store/data/data.slice';
import { getEpisodesDataAsync } from '../../store/episodes/episodes.slice';
import { changeEventDisplayVisible } from '../../store/ui/ui.slice';
import { getHurricaneDataAsync } from '../../store/alternate-data/alternate-data.slice';
import { selectCurrentLocation } from '../../store/map/map.selector';

import './theme-selector.styles.scss';

export default function ThemeSelector() {
  const dispatch = useDispatch();
  const currentValue = useSelector(selectTheme);
  const loc = useSelector(selectCurrentLocation);

  const handleChange = async (e) => {
    const newTheme = selectThemeById(e.target.value);

    if (e.target.value === 5) {
      dispatch(getHurricaneDataAsync(loc.geometry));
    }

    dispatch(changeEventDisplayVisible(false));
    await dispatch(
      changeTheme({
        id: newTheme.id,
        dataType: newTheme.initAttr < 2000 ? 'climate' : 'hazard',
        attrId: newTheme.initAttr,
      })
    );

    await dispatch(getDataAsync());

    const arg = { type: 'changeAttribute', payload: newTheme.initAttr };
    if (newTheme.initAttr < 2000) {
      dispatch(getProjectionDataAsync(arg));
    } else {
      dispatch(getEpisodesDataAsync(arg));
    }
  };

  const themeOptions = useMemo(() => {
    return themeGroupings
      .sort((a, b) => a.name > b.name)
      .map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ));
  }, []);

  return (
    <div>
      <TextField
        select
        label='Themes'
        variant='standard'
        value={currentValue}
        onChange={handleChange}
      >
        {themeOptions}
      </TextField>
    </div>
  );
}
